import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';

import CustomInfoDialog from '../../../components/CustomInfoDialog/CustomInfoDialog';
import { gaEvent } from '../../../../utils/googleAnalytics';

import messages from './messages';
import styles from './styles';

function CustomInformation({
    booking,
    classes,
    handleCloseCustomInfoDialog,
    handleOpenCustomInfoDialog,
    openCustomInfoDialog,
}) {
    return (
        <div className={classes.contentContainer}>
            <Paper className={classes.paperContainer} elevation={1}>
                <h2><FormattedMessage {...messages.lblCustomInformation} /></h2>
                <Table className={classes.bookingTable}>
                    <TableHead>
                        <TableRow>
                            <TableCell>
                                <FormattedMessage {...messages.lblCustomInformationType} />
                            </TableCell>
                            <TableCell>
                                <FormattedMessage {...messages.lblCustomInformationValue} />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody className={classes.tableWrapper}>
                        <TableRow>
                            <TableCell className={classes.bookingTableRow}>
                                <FormattedMessage {...messages.lblCustomInformationReferenceNumber} />
                            </TableCell>
                            <TableCell id="srtBookingCustomInfo_refNumber" className={classes.bookingTableRow}>
                                { booking.BookingExternalIdentification.BookingExternalIdReferenceNumber }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.bookingTableRow}>
                                <FormattedMessage {...messages.lblCustomInformationPONumber} />
                            </TableCell>
                            <TableCell id="srtBookingCustomInfo_poNumber" className={classes.bookingTableRow}>
                                { booking.BookingExternalIdentification.BookingExternalIdPoNumber }
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell className={classes.bookingTableRow}>
                                <FormattedMessage {...messages.lblCustomInformationCustomerNumber} />
                            </TableCell>
                            <TableCell id="srtBookingCustomInfo_customer" className={classes.bookingTableRow}>
                                { booking.BookingExternalIdentification.BookingExternalIdCustomerNumber }
                            </TableCell>
                        </TableRow>
                        {booking.BookingCustomInformation.map((customInfo, index) => (
                            <TableRow key={`ci_${index}`}>
                                <TableCell id={`srtCustomInfoType_${index}`}>
                                    {customInfo.BookingCustomInformationType}
                                </TableCell>
                                <TableCell id={`srtCustomInfoValue_${index}`}>
                                    {customInfo.BookingCustomInformationValue}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
                <Button
                    variant="contained"
                    id="srtBookingEditCustomInformation"
                    color="secondary"
                    onClick={() => {
                        gaEvent('bookingCustomInformationOpen');
                        handleOpenCustomInfoDialog();
                    }}
                >
                    <FormattedMessage {...messages.btnCustomInformationEdit} />
                </Button>
                <CustomInfoDialog
                    booking={booking}
                    onCloseCustomInfoDialog={handleCloseCustomInfoDialog}
                    open={openCustomInfoDialog}
                />
            </Paper>
        </div>
    );
}

CustomInformation.propTypes = {
    booking: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    handleCloseCustomInfoDialog: PropTypes.func.isRequired,
    handleOpenCustomInfoDialog: PropTypes.func.isRequired,
    openCustomInfoDialog: PropTypes.bool.isRequired,
};

export default withStyles(styles)(CustomInformation);
